import ShimmerLoader from '@components/ShimmerLoader/ShimmerLoader';
import type { FC } from 'react';

import styles from './EmailSignatureCompactLayoutSilhouette.module.scss';

const EmailSignaturePreviewShimmer: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <ShimmerLoader>
      {(props) => (
        <div className={styles['silhouette-compact-body']}>
          <div className={styles['images-silhouette-group']} data-is-real-size={'true'}>
            <div className={styles['primary-image-placeholder']} data-is-real-size={'true'} {...props}></div>
            <div
              className={styles['secondary-image-placeholder']}
              data-is-real-size={'true'}
              {...props}
            ></div>
          </div>
          <div className={styles['compact-second-cell-silhouette']}>
            <div className={styles['personal-silhouette-group-horizontal-group']}>
              <div className={styles['personal-info-group-silhouette']}>
                <div
                  className={styles['primary-personal-details-silhouette']}
                  data-is-real-size={'true'}
                  {...props}
                />
                <div
                  className={styles['secondary-personal-details-silhouette']}
                  data-is-real-size={'true'}
                  {...props}
                />
                <div
                  className={styles['personal-details-headline-silhouette']}
                  data-is-real-size={'true'}
                  {...props}
                />
              </div>
            </div>
            <div className={styles['divider-silhouette']} data-is-real-size={'true'} {...props}></div>
            <div className={styles['contact-details-compact-containers']} data-is-real-size={'true'}>
              <div className={styles['contact-details-containers']}>
                <div className={styles['field-silhouette-container']}>
                  <div
                    className={styles['contact-details-dot-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                  <div
                    className={styles['contact-details-field-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                </div>
                <div className={styles['field-silhouette-container']}>
                  <div
                    className={styles['contact-details-dot-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                  <div
                    className={styles['contact-details-field-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                </div>
              </div>
              <div className={styles['contact-details-containers']} data-is-real-size={'true'}>
                <div className={styles['field-silhouette-container']}>
                  <div
                    className={styles['contact-details-dot-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                  <div
                    className={styles['contact-details-field-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                </div>
                <div className={styles['field-silhouette-container']}>
                  <div
                    className={styles['contact-details-dot-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                  <div
                    className={styles['contact-details-field-silhouette']}
                    data-is-real-size={'true'}
                    {...props}
                  />
                </div>
              </div>
            </div>
            <div className={styles['divider-silhouette']} data-is-real-size={'true'} {...props}></div>
            <div className={styles['social-icons-container-silhouette']} data-is-real-size={'true'}>
              <div className={styles['social-icon-silhouette']} data-is-real-size={'true'} {...props} />
              <div className={styles['social-icon-silhouette']} data-is-real-size={'true'} {...props} />
              <div className={styles['social-icon-silhouette']} data-is-real-size={'true'} {...props} />
              <div className={styles['social-icon-silhouette']} data-is-real-size={'true'} {...props} />
            </div>
          </div>
        </div>
      )}
    </ShimmerLoader>
  );
};

export default EmailSignaturePreviewShimmer;
